import React, {useState, useEffect} from 'react';
import PubSub from 'services/PubSub/';
import { useViewportMediaQuery } from 'hooks';
import {chatOrdersFlag} from 'config';
import style from './style.scss';//NOSONAR

let actions = [];

const MessageInfo = () => {
    if(!chatOrdersFlag)  return '';
    const notView = typeof window !== 'undefined' && (window.location.pathname.indexOf('/centro-ayuda') !== -1) && (window.location.pathname.indexOf('/_secure/cart') !== -1);
    if(notView) return '';
    const isMobile = useViewportMediaQuery('1024');
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        if(isMobile) {
            if(!hidden) {
                PubSub.dispatch('message_info_chat', {visibility: false}); 
            }
            actions.push(PubSub.register('open_tooltip', openFakeTooltip));
        }
    }, [isMobile]);

    const openFakeTooltip = (payload) => {
        PubSub.dispatch('message_info_chat', {visibility: !payload.value});
        setHidden(!payload.value);
    }

    const click = () => {
        PubSub.dispatch('message_info_chat', {visibility: true});
        setHidden(true);
    }

    if(hidden) return '';

    return(
        isMobile && <div className="message-info-chat">
            <div className="message-info-wrapper">
                <i className="jumbo-icon-chat-menssage"></i>
                <span>Tienes <strong>2 mensajes</strong> de tu shopper</span>
            </div>
            <button className="message-info-chat-btn" onClick={click}>Leer</button>
        </div>
    )
}

export default MessageInfo;
